import { render, staticRenderFns } from "./braceletDetail.vue?vue&type=template&id=7649ec94&scoped=true"
import script from "./braceletDetail.vue?vue&type=script&lang=js"
export * from "./braceletDetail.vue?vue&type=script&lang=js"
import style0 from "./braceletDetail.vue?vue&type=style&index=0&id=7649ec94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7649ec94",
  null
  
)

export default component.exports